<template>
    <div class="container">
        <div v-if="options?.length" v-for="item in options" :key="item.id"
            :class="{ selected: item.id === value, 'container-item': true }" @click="emit('change', item)">
            <img :src="item.mediaUrl" :alt="item.text" />
            <span>{{ item.text }}</span>
        </div>
        <div v-else class="flex items-center justify-center w-full">
            Sorry, but there are no options to choose from
        </div>
    </div>
</template>
<script setup lang="ts">
import type { IDonatePaymentMethodsProps, IPaymentOption } from './DonatePaymentMethods.model';

const { options } = defineProps<IDonatePaymentMethodsProps>()

const emit = defineEmits<{
    (e: 'change', value: IPaymentOption): void;
}>();

</script>
<style scoped lang="scss">
.container {
    border-radius: 12px;
    box-shadow: 0 0px 1px rgba(0, 0, 0, 0.34);
    height: 150px;
    padding: 10px 15px;
    display: flex;
    gap: 10px;
    justify-content: center;
}

.container-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 2px;
    padding: 5px;
    border-radius: 8px;
    border: 2px solid transparent;
    cursor: pointer;
    flex: 0;
    min-width: 200px;

    &:hover:not(.selected) {
        border: 2px dashed var(--primary)
    }


    img {
        min-height: 0%;
        display: block;
        object-fit: contain;
    }
}

.selected {
    border: 2px solid var(--primary);
    background-color: #f0fdf4;
}
</style>